import { useCallback } from 'react'
import { useSlsDispatchContext } from '@fs/zion-sls'
import { useR2DispatchContext } from '../../../providers/r2Provider/R2Context'
import {
  useSharedBrowserDispatchContext,
  useSharedBrowserStateContext,
} from '../../../../shared/providers/sharedBrowserProvider/SharedBrowserContext'

export default function useSetReferenceFocusedIndex() {
  const r2Dispatch = useR2DispatchContext()
  const sharedBrowserState = useSharedBrowserStateContext()
  const sharedBrowserDispatch = useSharedBrowserDispatchContext()
  const slsDispatch = useSlsDispatchContext()

  return useCallback(
    (value) => {
      r2Dispatch({ type: 'SET_REFERENCE_FOCUSED_INDEX', value })
      const newReferenceArk = sharedBrowserState.thumbnails?.[value]?.ark
      if (newReferenceArk) {
        slsDispatch({ type: 'ADD_ARKS_TO_LOAD', value: [newReferenceArk] })
        // Mark the reference image viewed so its "viewed" badge shows in the split-screen ribbon/grid.
        sharedBrowserDispatch({ type: 'MARK_IMAGE_VIEWED', value: newReferenceArk })
      }
    },
    [r2Dispatch, slsDispatch, sharedBrowserState.thumbnails, sharedBrowserDispatch]
  )
}
